<template>
    <el-dialog title="业绩" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form">
            <el-form-item label="个人业绩" :label-width="formLabelWidth">
                <el-input v-model="form.user_achievement" autocomplete="off" type="text" disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="团队业绩" :label-width="formLabelWidth">
                <el-input v-model="form.achievement" autocomplete="off" type="text" disabled="true"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import UserApi from '@/api/user.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,

            };
        },
        props: ['open','form'],
        watch: {
          open: function(n, o) {
            if (n != o) {
              this.dialogVisible = this.open;
            }
          }
        },
        created() {
        },
        methods: {
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Achievement.vue